import CheckListSelector from './src/main';

/* istanbul ignore next */
CheckListSelector.install = function(Vue) {
  Vue.component(CheckListSelector.name, CheckListSelector);
};

export default CheckListSelector;
